import RequestService from './request-service';

/** 
 * @typedef {Object} AlgoOddRequestParams
 * @property {number} mid - match id
 * @property {number} sid - sport id
 * @property {boolean} il - is live
 * @property {number} tid - tournament id
 * @property {string} ht - home team
 * @property {string} at - away team
 * @property {string} tn - tournament name
 * @property {string} i - betradar id
 * @property {AlgoOddRequestOutcome[]} outi - outcomes infos
 */

/** 
 * @typedef {Object} AlgoOddRequestOutcome
 * @property {number} oid - market id
 * @property {number} otoid - outcome id
 * @property {number} odd - odd
 * @property {boolean} issbv - is sbv flag
 * @property {boolean} ipm - is player market
 * @property {string} sbv - special bet value
 * @property {string} id - identifier
*/

// Query the Pricing Engine for a price
export default class AlgoOddRequest extends RequestService {
  /**
   * Class constructor method
   * @param {AlgoOddRequestParams} params - algo odd request params
   */
  constructor(params) {
    super();
    this.endpoint = this.$config.endpoints.algoOdd;
    /**
     * Request method
     * @type {string}
     */
    this.method = 'post';

    /**
     * Request params
     * @type {AlgoOddRequestParams}
     */
    this.postParams = params;
  }
}
